// This is auto generated : Don't make edits here.
// Add them to the vocab in the CRM then export using _temp/portalvocab)
// Incept date : 2020-03-20 - 17:15:42
export default {
  "de":{
    "banners":{
      "sold":"Verkauft",
      "lastunits":"Letzte Objekte",
      "newlisting":"Neue Listings",
      "soldout":"Ausverkauft",
      "reserved":"Reserviert",
      "reduced":"Reduzierter Preis",
      "comingsoon":"Kommt bald",
      "removed":"Entfernt"
    },
    "favourites":{
      "copymodal":{
        "bodyauto":"Es wurde ein Link zu Ihren aktuellen Immobilien in Ihrer Auswahl in Ihren Zwischenspeicher Einfügen kopiert. Sie können ihn in eine Email/Twitter etc. einfügen.",
        "title":"Teilen Sie Ihre Auswahl",
        "bodymanual":"Kopieren Sie den nachfolgenden Link, um Ihre Auswahl per Email, Twitter etc. zu teilen"
      },
      "button":{
        "add":"Speichern",
        "share_start":"Einen gemeinsam benutzbaren Link zu Ihren gespeicherten Immobilien erstellen",
        "inforequest":"Weitere Informationen zu den gespeicherten Immobilien anfordern",
        "share_end":"Den gemeinsam benutzbaren Link zu Ihren gespeicherten Immobilien löschen",
        "remove":"Gespeichert",
        "share":"Link kopieren"
      },
      "title":"Gespeicherte Immobilien"
    },
    "property":{
      "pricing":{
        "por":"Preis auf Anfrage",
        "price":"Preis",
        "from":"Preis ab"
      },
      "removed_explaination":"Tut uns leid, diese Immobilie ist auf unserer Website nicht mehr verfügbar."
    },
    "recents":{
      "title":"Kürzlich angesehen"
    },
    "welcome":{
      "signout":"Abmelden",
      "hello":"MyLucasFox"
    },
    "classes":{
      "res_sale":"Verkäufe von Wohnimmobilien",
      "com_sale":"Gewerbeverkäufe",
      "basic_sale":"Verkäufe von Wohnimmobilien",
      "com_rent":"Gewerbevermietungen",
      "res_rent":"Langzeitvermietungen",
      "res_short":"Kurzzeitvermietungen"
    },
    "searches":{
      "priceto":"bis",
      "baths":"Badezimmer",
      "copymodal":{
        "bodyauto":"Es wurde ein Link zu dieser Suche in Ihren Zwischenspeicher Einfügen kopiert. Sie können ihn in eine Email/Twitter etc. einfügen.",
        "title":"Teilen Sie Ihre Suche",
        "bodymanual":"Kopieren Sie den nachfolgenden Link, um diese Suche per Email, Twitter etc. zu teilen"
      },
      "savemodal":{
        "titleexisting":"Suche bereits gespeichert",
        "title":"Suche gespeichert"
      },
      "newdev_offplan":"Neubaten",
      "button":{
        "saved":"Suche gespeichert",
        "remove":"Entfernen",
        "save":"Diese Suche speichern",
        "share":"Link kopieren"
      },
      "unfurnished":"Unmöbliert",
      "people":"Personen",
      "title":"Gespeicherte Suchvorgänge",
      "furnished":"Möbliert",
      "beds":"Schlafzimmer",
      "features":"Mit"
    },
    "features":{
      "terrace":"Terrasse",
      "waterfront":"Immobilie in erster Linie",
      "newbuild":"Neubau",
      "garden":"Garten",
      "pool":"Pool",
      "seaview":"Meerblick",
      "rentallicence":"Mietlizenz",
      "furnished":"Möbliert",
      "parking":"Parkplatz",
      "elevator":"Aufzug"
    }
  },
  "ru":{
    "banners":{
      "sold":"Продано",
      "lastunits":"Последний шанс",
      "newlisting":"Новый объект недвижимости",
      "soldout":"Продано",
      "reserved":"Зарезервировано",
      "reduced":"Сниженная цена",
      "comingsoon":"Cкоро",
      "removed":"Удалено"
    },
    "favourites":{
      "copymodal":{
        "bodyauto":"Ссылка на объект, находящиеся в вашей коллекции, была скопирована в ваш буфер вставки. Вы можете вставить его в электронную почту / твиттер и т. д.",
        "title":"Поделитесь своей коллекцией",
        "bodymanual":"Скопируйте ссылку ниже, чтобы поделиться своей коллекцией по электронной почте, твиттеру и т. д."
      },
      "button":{
        "add":"Сохранить",
        "share_start":"Создать ссылку чтобы поделиться сохраненными объектами",
        "inforequest":"Запросить подробную информацию по сохраненным объектам",
        "share_end":"Удалить ссылку на ваши сохраненные объекты",
        "remove":"Сохранено",
        "share":"Скопировать ссылку"
      },
      "title":"Сохраненные объекты"
    },
    "property":{
      "pricing":{
        "por":"Цена по запросу",
        "price":"Цена",
        "from":"Цены от"
      },
      "removed_explaination":"Извините, данный объект уже не доступен на нашем сайте."
    },
    "recents":{
      "title":"Недавно просмотренные"
    },
    "welcome":{
      "signout":"Выход",
      "hello":"MyLucasFox"
    },
    "classes":{
      "res_sale":"Покупка недвижимости",
      "com_sale":"Продажа коммерческой недвижимости",
      "basic_sale":"Покупка недвижимости",
      "com_rent":"Аренда коммерческой недвижимости",
      "res_rent":"Аренда недвижимости",
      "res_short":"Краткосрочная аренда"
    },
    "searches":{
      "priceto":"до",
      "baths":"ванные комнаты",
      "copymodal":{
        "bodyauto":"Ссылка на этот поиск была скопирована в ваш буфер вставки. Вы можете вставить его в электронную почту / твиттер и т. д.",
        "title":"Поделитесь своим поиском",
        "bodymanual":"Скопируйте ссылку ниже, чтобы поделиться своей коллекцией по электронной почте, твиттеру и т. д."
      },
      "savemodal":{
        "titleexisting":"Поиск уже сохранен",
        "title":"Поиск сохранен"
      },
      "newdev_offplan":"Новостройки",
      "button":{
        "saved":"Поиск сохранен",
        "remove":"Удалить",
        "save":"Сохранить этот поиск",
        "share":"Скопировать ссылку"
      },
      "unfurnished":"Без мебели",
      "people":"Количество человек",
      "title":"Сохраненные поисковые запросы",
      "furnished":"С мебелью",
      "beds":"cпальни",
      "features":","
    },
    "features":{
      "terrace":"Терраса",
      "waterfront":"Первая береговая линия",
      "newbuild":"Новое строительство",
      "garden":"Сад",
      "pool":"Бассейн",
      "seaview":"Вид на море",
      "rentallicence":"Лицензия на сдачу аренду",
      "furnished":"Меблированный",
      "parking":"Гараж",
      "elevator":"Лифт"
    }
  },
  "sv":{
    "banners":{
      "sold":"Såld",
      "lastunits":"Senaste enheterna",
      "newlisting":"Nyhet",
      "soldout":"Slutsåld",
      "reserved":"Reserverad",
      "reduced":"Reducerat pris",
      "comingsoon":"Inom kort",
      "removed":"Borttagen"
    },
    "favourites":{
      "copymodal":{
        "bodyauto":"En länk till fastigheterna du för tillfället har i din samling har kopierats till din klistra buffer.  Du kan klistra den i ett mail/twitter osv.",
        "title":"Dela din samling",
        "bodymanual":"Kopiera länken nedan för att dela din samling via email, twitter osv."
      },
      "button":{
        "add":"Lägg till",
        "share_start":"Börja dela din samling med en offentlig länk",
        "inforequest":"Begär mer information",
        "share_end":"Sluta dela din samling",
        "remove":"Ta bort",
        "share":"Kopiera länk"
      },
      "title":"Favoriter fastigheter"
    },
    "property":{
      "pricing":{
        "por":"Pris vid förfrågan",
        "price":"Pris",
        "from":"Pris from"
      }
    },
    "recents":{
      "title":"Nyligen visad"
    },
    "welcome":{
      "signout":"Logga ut",
      "hello":"MyLucasFox"
    },
    "classes":{
      "res_sale":"Fastigheter till salu",
      "com_sale":"Kommersiell försäljning",
      "basic_sale":"Fastigheter till salu",
      "com_rent":"Kommersiell uthyrning",
      "res_rent":"Långtidsuthyrning",
      "res_short":"Korttidsuthyrning"
    },
    "searches":{
      "priceto":"till och med",
      "baths":"Badrum",
      "copymodal":{
        "bodyauto":"En länk till denna sökningen har blivit kopierad till din klistra buffer. Du kan klistra den i ett mail/twitter osv.",
        "title":"Dela din sökning",
        "bodymanual":"Kopiera länken nedan för att dela din samling via email, twitter osv."
      },
      "savemodal":{
        "titleexisting":"Sökning redan sparad",
        "title":"Sökning sparad"
      },
      "newdev_offplan":"Nyproduktioner",
      "button":{
        "saved":"Sökning sparad",
        "remove":"Ta bort",
        "save":"Spara denna sökningen",
        "share":"Kopiera länk"
      },
      "unfurnished":"Omöblerad",
      "people":"Sovplatser",
      "title":"Sparade sökningar",
      "furnished":"Möblerad",
      "beds":"Sovrum",
      "features":"med"
    },
    "features":{
      "terrace":"Terrass",
      "waterfront":"Första linjen fastighet",
      "newbuild":"Nya utvecklingar",
      "garden":"Trädgård",
      "pool":"Pool",
      "seaview":"Havsutsikt",
      "rentallicence":"Hyresavtal",
      "furnished":"Möblerad",
      "parking":"Parkering",
      "elevator":"Hiss"
    }
  },
  "en":{
    "banners":{
      "sold":"Sold",
      "lastunits":"Last remaining units",
      "newlisting":"New listing",
      "soldout":"Sold out",
      "reserved":"Reserved",
      "reduced":"Reduced Price",
      "comingsoon":"Coming soon",
      "removed":"Removed"
    },
    "favourites":{
      "copymodal":{
        "bodyauto":"A link to the properties currently in your collection has been copied to your paste buffer.  You can paste it into email/twitter etc.",
        "title":"Share your collection",
        "bodymanual":"Copy the link below to share your collection via email, twitter etc."
      },
      "button":{
        "add":"Save",
        "share_start":"Create shareable link to your saved properties",
        "inforequest":"Request more information on saved properties",
        "share_end":"Delete shareable link to your saved properties",
        "remove":"Saved",
        "share":"Copy link"
      },
      "title":"Saved properties"
    },
    "property":{
      "pricing":{
        "por":"Price on request",
        "price":"Price",
        "from":"Prices from"
      },
      "removed_explaination":"Sorry, this property is no longer available on our website."
    },
    "recents":{
      "title":"Recently viewed"
    },
    "welcome":{
      "signout":"Sign out",
      "hello":"MyLucasFox"
    },
    "classes":{
      "res_sale":"Residential Sales",
      "com_sale":"Commercial Sales",
      "basic_sale":"Residential Sales",
      "com_rent":"Commercial Rentals",
      "res_rent":"Residential Rentals",
      "res_short":"Holiday Rentals"
    },
    "searches":{
      "priceto":"Up to",
      "baths":"Baths",
      "copymodal":{
        "bodyauto":"A link to this search has been copied to your paste buffer.  You can paste it into email/twitter etc.",
        "title":"Share your search",
        "bodymanual":"Copy the link below to share this search via email, twitter etc."
      },
      "savemodal":{
        "titleexisting":"Search already saved",
        "title":"Search saved"
      },
      "button":{
        "saved":"Search saved",
        "remove":"Remove",
        "save":"Save this search",
        "share":"Copy link"
      },
      "newdev_resale":"Resales",
      "furnished":"Furnished",
      "beds":"Beds",
      "features":"With",
      "newdev_offplan":"Off-plan",
      "unfurnished":"Unfurnished",
      "people":"Sleeps",
      "title":"Saved searches"
    },
    "features":{
      "terrace":"Terrace",
      "waterfront":"Waterfront",
      "newbuild":"New build",
      "garden":"Garden",
      "pool":"Pool",
      "seaview":"Sea view",
      "rentallicence":"Rental licence",
      "furnished":"Furnished",
      "parking":"Parking",
      "elevator":"Elevator"
    }
  },
  "it":{
    "banners":{
      "sold":"Venduto",
      "lastunits":"Ultime unità",
      "newlisting":"Nuova proprieta",
      "soldout":"Venduto",
      "reserved":"Riservato",
      "reduced":"Prezzo ridotto",
      "comingsoon":"Prossimamente",
      "removed":"Eliminato"
    },
    "favourites":{
      "copymodal":{
        "bodyauto":"Un link alle proprietà attualmente nella tua collezione è stato copiato. Puoi incollarlo in email / twitter ecc.",
        "title":"Condividi la tua collezione",
        "bodymanual":"Copia il link qui sotto per condividere la tua collezione via e-mail, Twitter, ecc."
      },
      "button":{
        "add":"Aggiungere",
        "share_start":"Inizia a condividere la tua collezione con un link pubblico",
        "inforequest":"Richiedi più' informazioni",
        "share_end":"Interrompere la condivisione della vostra collezione",
        "remove":"Eliminare",
        "share":"Copia Link"
      },
      "title":"Proprietà favorite"
    },
    "property":{
      "pricing":{
        "por":"Prezzo su richiesta",
        "price":"Prezzo",
        "from":"Prezzo da"
      },
      "removed_explaination":"Spiacenti, questa proprietà non è più disponibile sul nostro sito web."
    },
    "recents":{
      "title":"Viste recentemente"
    },
    "welcome":{
      "signout":"Esci",
      "hello":"MyLucasFox"
    },
    "classes":{
      "res_sale":"Proprietà' in vendita",
      "com_sale":"Vendite Commerciali",
      "basic_sale":"Proprietà in vendita",
      "com_rent":"Affitti commerciali",
      "res_rent":"Proprietà in affitto",
      "res_short":"Affitti per vacanze"
    },
    "searches":{
      "priceto":"fino a",
      "baths":"Bagni",
      "copymodal":{
        "bodyauto":"Il link a questa ricerca è stato copiato. Puoi incollarlo in email / twitter ecc.",
        "title":"Condividi la tua ricerca",
        "bodymanual":"Copia il link qui sotto per condividere questa ricerca via email, twitter ecc."
      },
      "savemodal":{
        "titleexisting":"Ricerca già salvata",
        "title":"Ricerca salvata"
      },
      "newdev_offplan":"Nuove Costruzioni",
      "button":{
        "saved":"Ricerca salvata",
        "remove":"Eliminare",
        "save":"Salva questa ricerca",
        "share":"Copia Link"
      },
      "unfurnished":"Non ammobiliato",
      "people":"Persone",
      "title":"Ricerche salvate",
      "furnished":"Ammobiliato",
      "beds":"Camera da letto",
      "features":"Con"
    },
    "features":{
      "terrace":"Terrazza",
      "waterfront":"Lungomare",
      "newbuild":"Nuova costruzione",
      "garden":"Giardino",
      "pool":"Piscina",
      "seaview":"Vista sul mare",
      "rentallicence":"Licenza di affitto",
      "furnished":"Ammobiliato",
      "parking":"Parcheggio",
      "elevator":"Ascensore"
    }
  },
  "fr":{
    "banners":{
      "sold":"Vendu",
      "lastunits":"Dernières unités",
      "newlisting":"Propriété Nouvelle",
      "soldout":"Vendu",
      "reserved":"Réservé",
      "reduced":"Prix réduit",
      "comingsoon":"À venir",
      "removed":"Supprimé"
    },
    "favourites":{
      "copymodal":{
        "bodyauto":"Un lien redirigeant vers les propriétés que vous avez sauvegardées a été copié dans votre presse-papier. Vous pouvez désormais le coller dans e-mail, sur twitter, etc.",
        "title":"Partagez votre liste de propriétés",
        "bodymanual":"Copiez le lien ci-dessous pour partager votre liste de propriétés par e-mail, twitter, etc."
      },
      "button":{
        "add":"Ajouter",
        "share_start":"Commencez à partager votre collection avec un lien public",
        "inforequest":"Demander plus d'information",
        "share_end":"Ne plus partager votre collection",
        "remove":"Supprimer",
        "share":"Copier ce lien"
      },
      "title":"Biens Favoris"
    },
    "property":{
      "pricing":{
        "por":"Prix à consulter",
        "price":"Prix",
        "from":"Prix à partir de"
      },
      "removed_explaination":"Désolé, cette propriété n'est plus disponible sur notre site."
    },
    "recents":{
      "title":"Vues récemment"
    },
    "welcome":{
      "signout":"Déconnexion",
      "hello":"MyLucasFox"
    },
    "classes":{
      "res_sale":"Propriétés à vendre",
      "com_sale":"Propriétés commerciales",
      "basic_sale":"Propriétés à vendre",
      "com_rent":"Locations commerciales",
      "res_rent":"Locations à long terme",
      "res_short":"Location à court terme"
    },
    "searches":{
      "priceto":"jusqu'à",
      "baths":"Salles de bains",
      "copymodal":{
        "bodyauto":"Un lien redirigeant vers cette recherche a été copié dans votre presse-papier. Vous pouvez désormais le coller dans e-mail / twitter etc.",
        "title":"Partagez votre recherche",
        "bodymanual":"Copiez le lien ci-dessous pour partager cette recherche par e-mail, twitter, etc."
      },
      "savemodal":{
        "titleexisting":"Recherche déjà enregistrée",
        "title":"Recherche sauvegardée"
      },
      "newdev_offplan":"Constructions",
      "button":{
        "saved":"Recherche sauvegardée",
        "remove":"Supprimer",
        "save":"Sauvegarder cette recherche",
        "share":"Copier ce lien"
      },
      "unfurnished":"Non meublé",
      "people":"Personnes",
      "title":"Recherches sauvegardées",
      "furnished":"Meublé",
      "beds":"Chambres",
      "features":"Avec"
    },
    "features":{
      "terrace":"Terrasse",
      "waterfront":"Propriété de bord de mer",
      "newbuild":"Nouvellement construit",
      "garden":"Jardin",
      "pool":"Piscine",
      "seaview":"Vue sur mer",
      "rentallicence":"Permis de louer.",
      "furnished":"Meublé",
      "parking":"Parking",
      "elevator":"Ascenseur"
    }
  },
  "es":{
    "banners":{
      "sold":"Vendido",
      "lastunits":"Últimas unidades",
      "newlisting":"Propiedad Nueva",
      "soldout":"Vendido",
      "reserved":"Reservado",
      "reduced":"Precio reducido",
      "comingsoon":"Próximamente",
      "removed":"Eliminado"
    },
    "favourites":{
      "copymodal":{
        "bodyauto":"Se ha copiado un enlace en las propiedades actualmente en su colección en su portapapeles. Ahora puede pegarlo en email/twitter, etc.",
        "title":"Compartir su colección",
        "bodymanual":"Copiar el siguiente enlace para compartir su colección en email, twitter, etc."
      },
      "button":{
        "add":"Añadir",
        "share_start":"Crear enlace para compartir sus propiedades guardadas",
        "inforequest":"Solicitar más información sobre propiedades guardadas",
        "share_end":"Eliminar enlace para compartir sus propiedades guardadas",
        "remove":"Guardado",
        "share":"Copiar enlace"
      },
      "title":"Propiedades guardadas"
    },
    "property":{
      "pricing":{
        "por":"Precio a consultar",
        "price":"Precio",
        "from":"Precio desde"
      },
      "removed_explaination":"Esta propiedad ya no está disponible en nuestra web."
    },
    "recents":{
      "title":"Vistas recientemente"
    },
    "welcome":{
      "signout":"Cerrar sesión",
      "hello":"MyLucasFox"
    },
    "classes":{
      "res_sale":"Viviendas en venta",
      "com_sale":"Ventas comerciales",
      "basic_sale":"Propiedades en venta",
      "com_rent":"Alquileres comerciales",
      "res_rent":"Viviendas en alquiler",
      "res_short":"Alquiler de corta estancia"
    },
    "searches":{
      "priceto":"Hasta",
      "baths":"Baños",
      "copymodal":{
        "bodyauto":"Se ha copiado un enlace en esta búsqueda en su portapapeles. Puede pegarlo en email/twitter, etc.",
        "title":"Compartir su búsqueda",
        "bodymanual":"Copiar el siguiente enlace para compartir esta búsqueda en email, twitter, etc."
      },
      "savemodal":{
        "titleexisting":"Esta búsqueda ya se ha guardado",
        "title":"Búsqueda guardada"
      },
      "newdev_offplan":"Obra nueva",
      "button":{
        "saved":"Búsqueda guardada",
        "remove":"Eliminar",
        "save":"Guardar búsqueda",
        "share":"Copiar enlace"
      },
      "unfurnished":"No amueblado",
      "people":"Personas",
      "title":"Búsquedas guardadas",
      "furnished":"Amueblado",
      "beds":"Dormitorios",
      "features":"Con"
    },
    "features":{
      "terrace":"Terraza",
      "waterfront":"En primera línea de mar",
      "newbuild":"Obra nueva",
      "garden":"Jardín",
      "pool":"Piscina",
      "seaview":"Vistas al mar",
      "rentallicence":"Licencia de alquiler",
      "furnished":"Amueblado",
      "parking":"Parking",
      "elevator":"Ascensor"
    }
  },
  "ca":{
    "banners":{
      "sold":"Venut/uda",
      "lastunits":"Últimes unitats",
      "newlisting":"Proprietat Nova",
      "soldout":"Venut",
      "reserved":"Reservado",
      "reduced":"Preu rebaixat",
      "comingsoon":"Pròximament",
      "removed":"Eliminat"
    },
    "favourites":{
      "copymodal":{
        "bodyauto":"S’ha copiat un enllaç a les propietats que actualment hi ha a la seva col·lecció al porta-retalls. Ara pot enganxar-lo a email/twitter, etc.",
        "title":"Compartir la seva col·lecció",
        "bodymanual":"Copiar l’enllaç següent per compartir la seva col·lecció a email, twitter, etc."
      },
      "button":{
        "add":"Afegir",
        "share_start":"Crear enllaç per compartir els seus immobles guardats",
        "inforequest":"Sol·licitar més informació sobre immobles guardats",
        "share_end":"Eliminar enllaç per compartir els seus immobles guardats",
        "remove":"Guardat",
        "share":"Copiar enllaç"
      },
      "title":"Immobles guardats"
    },
    "property":{
      "pricing":{
        "por":"Preu a consultar",
        "price":"Preu",
        "from":"Preu des de"
      },
      "removed_explaination":"Aquesta propietat ja no està disponible a la nostra web."
    },
    "recents":{
      "title":"Vistes recentment"
    },
    "welcome":{
      "signout":"Tancar sessió",
      "hello":"MyLucasFox"
    },
    "classes":{
      "res_sale":"Immobles en venda",
      "com_sale":"Vendes comercials",
      "basic_sale":"Immobles en venda",
      "com_rent":"Lloguers comercials",
      "res_rent":"Lloguer de llarg termini",
      "res_short":"Lloguer de curt termini"
    },
    "searches":{
      "priceto":"Fins a",
      "baths":"Cambres de bany",
      "copymodal":{
        "bodyauto":"S’ha copiat un enllaç a aquesta cerca en el porta-retalls. Pot enganxar-lo a email/twitter, etc.",
        "title":"Compartir la seva cerca",
        "bodymanual":"Copiar l’enllaç següent per compartir aquesta cerca a email, twitter, etc."
      },
      "savemodal":{
        "titleexisting":"Aquesta cerca ja s'ha guardat",
        "title":"Cerca guardada"
      },
      "newdev_offplan":"Obra nova",
      "button":{
        "saved":"Cerca guardada",
        "remove":"Eliminar",
        "save":"Guardar cerca",
        "share":"Copiar enllaç"
      },
      "unfurnished":"No moblat",
      "people":"Gent",
      "title":"Cerques desades",
      "furnished":"Moblat",
      "beds":"Dormitoris",
      "features":"Amb"
    },
    "features":{
      "terrace":"Terrassa",
      "waterfront":"A primera línia de mar",
      "newbuild":"Obra nova",
      "garden":"Jardí",
      "pool":"Piscina",
      "seaview":"Vistes al mar",
      "rentallicence":"Llicència de lloguer",
      "furnished":"Moblat/ada",
      "parking":"Pàrquing",
      "elevator":"Ascensor"
    }
  },
  "zh":{
    "banners":{
      "sold":"已出售",
      "lastunits":"最后机会",
      "newlisting":"新房源",
      "soldout":"卖光了",
      "reserved":"已预订",
      "reduced":"价格降低",
      "comingsoon":"即将推出",
      "removed":"删除了"
    },
    "favourites":{
      "copymodal":{
        "bodyauto":"您收藏中房产的链接已被复制到您的粘贴缓冲区，你可以把它粘贴到微信/微博上等",
        "title":"分享你的收藏",
        "bodymanual":"为了微博，微信上共享此搜索，复制下面的链接"
      },
      "button":{
        "add":"保存",
        "share_start":"为了已保存的地产创建可共享的链接",
        "inforequest":"关于已保存地产的请求更多信息",
        "share_end":"删除已保存地产的可分享链接",
        "remove":"已保存",
        "share":"复制链接"
      },
      "title":"已保存的地产"
    },
    "property":{
      "pricing":{
        "por":"价格待询",
        "price":"价格",
        "from":"起价"
      },
      "removed_explaination":"对不起，这房产在我们的网站不再可用"
    },
    "recents":{
      "title":"您最近查看的房产"
    },
    "welcome":{
      "signout":"登出",
      "hello":"MyLucasFox"
    },
    "classes":{
      "res_sale":"买房",
      "com_sale":"找商铺",
      "basic_sale":"买房子",
      "com_rent":"租商铺",
      "res_rent":"找租房",
      "res_short":"短期租房"
    },
    "searches":{
      "priceto":"到",
      "baths":"卫",
      "copymodal":{
        "bodyauto":"此搜索的链接已复制到您的粘贴缓冲区， 你可以把它粘贴到微信/微博上等",
        "title":"分享您的搜索",
        "bodymanual":"为了微博，微信上共享此搜索，复制下面的链接"
      },
      "savemodal":{
        "titleexisting":"搜索已保存​了",
        "title":"保存搜索了"
      },
      "newdev_offplan":"新房",
      "button":{
        "saved":"保存搜索了",
        "remove":"删除",
        "save":"保存这个搜索",
        "share":"复制链接"
      },
      "unfurnished":"未附家具",
      "people":"人数",
      "furnished":"附家具",
      "beds":"室",
      "features":"包括"
    },
    "features":{
      "terrace":"露台",
      "waterfront":"海边别墅",
      "newbuild":"新建案",
      "garden":"花园",
      "pool":"游泳池",
      "seaview":"海景",
      "rentallicence":"租赁许可证",
      "furnished":"附家具",
      "parking":"停车场",
      "elevator":"电梯"
    }
  },
  "nl":{
    "banners":{
      "sold":"Verkocht",
      "lastunits":"Laatste eenheden",
      "newlisting":"Nieuws",
      "soldout":"Uitverkocht",
      "reserved":"Gereserveerd",
      "reduced":"In prijs verlaagd",
      "comingsoon":"Komt binnenkort"
    },
    "favourites":{
      "button":{
        "add":"Aan favorieten toevoegen",
        "inforequest":"Meer informatie aanvragen",
        "remove":"Verwijderen"
      },
      "title":"Favoriete woningen"
    },
    "property":{
      "pricing":{
        "por":"Prijs op aanvraag",
        "price":"Prijs",
        "from":"Prijs vanaf"
      }
    },
    "recents":{
      "title":"Recent bekeken"
    },
    "welcome":{
      "hello":"MyLucasFox"
    },
    "classes":{
      "res_sale":"Woningen te koop",
      "com_sale":"Commerciële verkoop",
      "basic_sale":"Woningen te koop",
      "com_rent":"Commerciële verhuur",
      "res_rent":"Huurwoningen lange termijn",
      "res_short":"Vakantiewoning te huur"
    },
    "searches":{
      "priceto":"tot",
      "baths":"Badkamers",
      "newdev_offplan":"Nieuwe builds",
      "button":{
        "remove":"Verwijderen"
      },
      "unfurnished":"Niet gemeubileerd",
      "people":"Slaapplaatsen",
      "title":"Bewaarde zoekopdrachten",
      "furnished":"gemeubileerd",
      "beds":"Slaapkamers",
      "features":"Met"
    },
    "features":{
      "terrace":"Terras",
      "waterfront":"Waterkant",
      "newbuild":"Nieuwbouw",
      "garden":"Tuin",
      "pool":"Zwembad",
      "seaview":"Uitzicht op de zee",
      "rentallicence":"Verhuur licentie",
      "furnished":"Gemeubileerd",
      "parking":"Parkeerplaats",
      "elevator":"Lift"
    }
  }
}


// WEBPACK FOOTER //
// ./src/vocab.js